export const LANGUAGE_NAMESPACES = Object.freeze({
  common: 'common',
})
